<template>
    <!--     非站内跳转，(微信环境下跳小程序另外处理)-->

    <div
        class="minisite-link"
        @click.prevent="
            (e) => {
                e.stopPropagation()
                handleActionClick()
            }
        "
        v-if="
            data.content.content.length &&
            data.content.content[0].url.length &&
            data.type !== ClickActionType.SITE_PAGES &&
            !(data.content.type === ClickActionContentType.MINI_PROGRAM && isWeixin())
        ">
        <slot></slot>
    </div>
    <!--站内跳转-->
    <div
        class="minisite-link"
        @click.prevent="
            (e) => {
                e.stopPropagation()
                handleLink()
            }
        "
        :class="{ 'current-lang': currentInfo.langId === data.content.content[0].url }"
        v-else-if="data.type === ClickActionType.SITE_PAGES">
        <slot></slot>
    </div>
    <!--跳转至模板详情页-->
    <div
        class="minisite-link"
        @click.prevent="
            (e) => {
                e.stopPropagation()
                handleDetailLink()
            }
        "
        :class="{ 'current-lang': currentInfo.langId === data.content.content[0].url }"
        v-else-if="data.type === 'detailLink'">
        <slot></slot>
    </div>
    <!--    链接为空-->
    <div class="minisite-link" v-else-if="!(data.content.content.length && data.content.content[0].url.length)">
        <slot></slot>
    </div>
    <!--    跳转小程序(仅微信环境下)-->
    <div
        class="minisite-link relative"
        ref="mpWrapper"
        v-else-if="data.content.type === ClickActionContentType.MINI_PROGRAM && isWeixin()">
        <slot></slot>
        <wx-open-launch-weapp
            :appid="data.content.content[0].appId"
            :path="data.content.content[0].path"
            id="openMPBtn"
            class="mp-wrapper"
            @launch="handleWeixinLaunch">
            <script type="text/wxtag-template">
                <style>
                    .open-weapp-btn {
                        color: #fff;
                        background-color: transparent;
                        border: none;
                        width: 10000px;
                        height: 10000px;
                    }
                </style>
                <button class="open-weapp-btn"></button>
            </script>
        </wx-open-launch-weapp>
    </div>
</template>
<slot v-else></slot>

<script>
    import { getADParams, getUtm } from "@/utils/preflight"
    import commonMixIn from "./../common.mixin"
    import { concatURI } from "@/utils/common"
    import { isWeixin } from "@/utils/userAgent"
    import {
        collect,
        ElementType,
        ClickActionType,
        ClickActionContentType,
        NormalLotteryTypeArr,
        isBigScreen,
        BigScreen
    } from "../../service/site"
    import { appendMaterialReference, getQueryParams } from "../../utils/linkParams"
    import { GetMaterialDetail } from "../../service/material"
    import { isPreviewEnv } from "@/utils/previewEnv"
    import { isTrustedParentIframe } from "@/utils/trustedParentIframe"

    export default {
        name: "ClickAction",
        mixins: [commonMixIn],
        props: {
            data: {},
            type: String,
            actionRemark: {}
        },
        data() {
            return {
                ClickActionContentType,
                ClickActionType
            }
        },
        mounted() {
            const _this = this
            if (this.data.content.type === "miniProgram" && isWeixin())
                [
                    this.$nextTick(() => {
                        const openMPBtn = _this.$refs.mpWrapper?.querySelector("#openMPBtn")
                        if (openMPBtn) {
                            openMPBtn.addEventListener("error", () => {
                                _this.handleActionClick()
                            })
                        }
                    })
                ]
        },
        methods: {
            isWeixin,
            async handleLink(e) {
                if (window.location.href !== this.getLink) {
                    if (this.type) {
                        try {
                            await collect("MINISITE_SYSTEM_CLICK_SITEPAGE", {
                                s_elementType: ElementType[this.type],
                                s_websiteName: this.data.content.content[0]?.title,
                                s_website: this.getLink
                            })
                        } catch (e) {
                            console.log(e)
                        }
                    }

                    window.location.href = this.getLink
                }
            },
            async collectClickView() {
                const click = {
                    originOpenId: this.originOpenId,
                    ...getUtm(),
                    title: this._pageTitle || document.title,
                    path: window.location.href,
                    name: this.data.remark || this.actionRemark,
                    to: this.getLink,
                    uaId: this._UAId,
                    pid: window.ca("get", "pid"),
                    tagIds: this._tagIds
                }
                if (window.cw && !isPreviewEnv() && !isTrustedParentIframe()) {
                    await window.cw("action", "clickview", click)
                }
            },
            async handleActionClick() {
                try {
                    await this.collectClickView()
                    if (this.data.type && !isPreviewEnv()) {
                        const data = this.data.content.content[0]

                        switch (this.data.type) {
                            case ClickActionType.BASIC:
                                await collect("MINISITE_SYSTEM_CLICK_BASICLINK", {
                                    s_elementType: ElementType[this.type],
                                    s_website: concatURI(this.getLink, getADParams())
                                })
                                break
                            case ClickActionType.SITE_PAGES: {
                                const res = await GetMaterialDetail("site", data?.id)
                                await collect("MINISITE_SYSTEM_CLICK_SITEPAGE", {
                                    s_elementType: ElementType[this.type],
                                    s_websiteName: res.title,
                                    s_website: concatURI(this.getLink, getADParams())
                                })
                                break
                            }

                            case ClickActionType.MATERIAL:
                                switch (this.data.content.type) {
                                    case ClickActionContentType.QUESTIONNAIRE: {
                                        const res = await GetMaterialDetail("form", data?.id)

                                        await collect("MINISITE_SYSTEM_CLICK_FORM", {
                                            s_elementType: ElementType[this.type],
                                            s_formName: res.title,
                                            s_formId: res.id,
                                            s_formInsideName: res.remark
                                        })
                                        break
                                    }
                                    case ClickActionContentType.LANDING_PAGE: {
                                        const res = await GetMaterialDetail("landingpage", data?.id)

                                        await collect("MINISITE_SYSTEM_CLICK_LANDINGPAGE", {
                                            s_elementType: ElementType[this.type],
                                            s_landingPageId: res.id,
                                            s_landingPageTitle: res.title,
                                            s_landingPageInsideName: res.remark
                                        })
                                        break
                                    }
                                    case ClickActionContentType.MINI_SITE: {
                                        await collect("MINISITE_SYSTEM_CLICK_MINISITE", {
                                            s_elementType: ElementType[this.type],
                                            s_toMiniSiteAddress: data?.url
                                        })
                                        break
                                    }

                                    case ClickActionContentType.ATTACHMENT: {
                                        const res = await GetMaterialDetail("attachment", data?.id)

                                        await collect("MINISITE_SYSTEM_CLICK_ATTACHMENT", {
                                            s_elementType: ElementType[this.type],
                                            s_attachmentName: res.title,
                                            s_attachmentId: res.id
                                        })
                                        break
                                    }
                                    case ClickActionContentType.LUCKY_DRAW: {
                                        const res = await GetMaterialDetail("lottery", data?.id)

                                        await collect("MINISITE_SYSTEM_CLICK_LOTTERY", {
                                            s_elementType: ElementType[this.type],
                                            s_lotteryId: data?.id,
                                            s_lotteryType: isBigScreen(Number(data?.lotteryType))
                                                ? BigScreen
                                                : NormalLotteryTypeArr[Number(data?.templateType)],
                                            s_lotteryTitle: res.title
                                        })
                                        break
                                    }
                                    case ClickActionContentType.WEBINAR: {
                                        const res = await GetMaterialDetail("webinar", data?.id)

                                        await collect("MINISITE_SYSTEM_CLICK_LIVE", {
                                            s_elementType: ElementType[this.type],
                                            s_liveId: res.id,
                                            s_liveTitle: res.title,
                                            s_liveInsideName: res.remark
                                        })
                                        break
                                    }
                                }
                                break
                            case ClickActionType.ACTIONS:
                                switch (this.data.content.type) {
                                    case ClickActionContentType.PHONE:
                                        await collect("MINISITE_SYSTEM_CLICK_TELEPHONE", {
                                            s_elementType: ElementType[this.type],
                                            s_telephone: data?.url
                                        })
                                        break
                                    case ClickActionContentType.EMAIL:
                                        await collect("MINISITE_SYSTEM_CLICK_EMAIL", {
                                            s_elementType: ElementType[this.type],
                                            s_email: data?.url
                                        })
                                        break
                                    case ClickActionContentType.MINI_PROGRAM:
                                        // 备用链接
                                        this.handleWeixinClick()
                                        break
                                }
                        }
                    }
                } catch (e) {
                    console.error(e)
                }

                if (
                    this.data.content.type === ClickActionContentType.PHONE ||
                    this.data.content.type === ClickActionContentType.EMAIL
                ) {
                    parent.window.location.href = this.getLink
                    return
                }

                parent.window.location.href = appendMaterialReference(this.getLink, {
                    ...getUtm(),
                    ...getADParams()
                })
            },
            handleDetailLink() {
                if (this._siteData) {
                    let _childPage = this._siteData.childPages?.filter((_) => {
                        return _.parentComponentId === this.$parent.data.id
                    })
                    let _link = `${this.currentInfo.protocol}//${this.currentInfo.host}/${this._siteId}/gmp/${_childPage[0].pageId}/${this.data.content.content[0].dataRowId}/${this._lang}`
                    // parent.window.location.href = _link
                }
            },
            handleWeixinLaunch() {
                // 两条上报独立发起，避免 clickview 等待或失败影响原有小程序事件。
                this.collectClickView().catch((e) => {
                    console.error(e)
                })
                return this.handleWeixinClick()
            },
            async handleWeixinClick() {
                const content = this.data.content.content[0]
                try {
                    await collect("MINISITE_SYSTEM_CLICK_MINIPROGRAM", {
                        s_elementType: ElementType[this.type],
                        s_appId: content?.appId,
                        s_pagePath: content?.path,
                        s_alternateWebLinks: content?.url
                    })
                } catch (e) {
                    console.log(e)
                }
            },
            handleUtmUrl(target) {
                const target_url = new URL(target)
                const targetQueryParams = getQueryParams(target_url)

                // 目标页面具有场景id，则剔除当前页面的id
                if ("config_id" in targetQueryParams) {
                    return concatURI(location.href, {
                        ["config_id"]: undefined
                    })
                }

                return location.href
            }
            // getUtmParams() {
            //     let _target = []
            //     _target.push({
            //         name: 'utm_source',
            //         value: GetQueryString('utm_source'),
            //     })
            //     _target.push({
            //         name: 'utm_campaign',
            //         value: GetQueryString('utm_campaign'),
            //     })
            //     _target.push({
            //         name: 'utm_medium',
            //         value: GetQueryString('utm_medium'),
            //     })
            //     _target.push({
            //         name: 'utm_term',
            //         value: GetQueryString('utm_term'),
            //     })
            //     _target.push({
            //         name: 'utm_content',
            //         value: GetQueryString('utm_content'),
            //     })
            //     let _val = _target.map((_) => {
            //         return _.value ? `${_.name}=${_.value}` : ''
            //     })
            //     _val = _compact(_val).join('&')
            //     return _val.length > 0 ? `?${_val}` : ''
            // }
        },
        computed: {
            getLink() {
                let querystring = window.location.href.split("?")[1]
                let _targetLink = this.data.content.content[0].url
                let _target = ""
                switch (this.data.type) {
                    case ClickActionType.SITE_PAGES:
                        _target = this.currentInfo.protocol + "//" + this.currentInfo.host + "/" + this._siteId + "/"
                        switch (this.data.content.type) {
                            // 站内页面跳转取消qs继承
                            case "langs":
                                if (
                                    this.currentInfo.langId &&
                                    this.currentInfo.langId !== this.data.content.content[0].url
                                ) {
                                    if (this.currentInfo.pageId !== "index") {
                                        _target = _target + this._pageId + "/" + this.data.content.content[0].url
                                    } else {
                                        _target = _target + "index" + "/" + this.data.content.content[0].url
                                    }
                                    // window.location.href = querystring ? (_target + '?' + querystring) : _target
                                    // window.location.href = _target
                                } else return window.location.href
                                break
                            case ClickActionContentType.HOME:
                                // 当前不是首页
                                if (this.currentInfo.pageId !== "index") {
                                    _target = _target + "index" + "/" + this._lang
                                    // window.location.href = querystring ? (_target + '?' + querystring) : _target
                                    // window.location.href = _target
                                }
                                break
                            default:
                                if (this.data.content.content[0].lang) {
                                    _target = this.data.content.content[0].url + "/" + this.data.content.content[0].lang
                                } else {
                                    _target = this.data.content.content[0].url
                                }
                                // + '/' + (this.data.content.content[0].lang || this._lang)
                                // window.location.href = querystring ? (_target + '?' + querystring) : _target
                                // window.location.href = _target
                                break
                        }

                        // 站内页面跳转需要继承utm参数
                        return _target
                    default:
                        switch (this.data.content.type) {
                            case "phone":
                                return "tel:" + _targetLink
                            case "email":
                                return "mailto:" + _targetLink
                            default:
                                querystring = this.handleUtmUrl(_targetLink).split("?")[1]

                                _targetLink = querystring
                                    ? _targetLink + (_targetLink.indexOf("?") > -1 ? "&" : "?") + querystring
                                    : _targetLink

                                return _targetLink
                        }
                }
            },
            currentInfo() {
                let host = window.location.host
                let protocol = window.location.protocol
                let _pathList = window.location.pathname.split("/")
                return {
                    host: host,
                    protocol: protocol,
                    siteId: _pathList[1],
                    pageId: _pathList[2],
                    langId: this._lang
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .minisite-link {
        text-decoration: none;
        cursor: pointer;

        &.langs-link {
            color: #0366d6;
        }

        &.current-lang {
            color: initial;
        }

        .mp-wrapper {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: 10;
            overflow: hidden;
        }
    }

    .relative {
        position: relative;
    }
</style>
